import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { WhatsappLogo, List, X } from "@phosphor-icons/react";
import { IMAGES, WHATSAPP_QUOTE_URL, navLinks } from "@/data/site";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "header-glass shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" data-testid="logo-link" className="flex-shrink-0">
            <img
              src={IMAGES.logo}
              alt="Finegraf Acabamentos"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center space-x-7" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive
                      ? "text-[#E73336]"
                      : isScrolled
                        ? "text-[#2B2B2B] hover:text-[#E73336]"
                        : "text-white hover:text-[#E73336]"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href={WHATSAPP_QUOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta-button"
            className="hidden xl:inline-flex items-center gap-2 px-6 py-3 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-colors btn-cta"
          >
            <WhatsappLogo weight="fill" size={20} />
            Orçamento
          </a>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? "Fechar menu" : "Abrir menu"}
            className={`xl:hidden p-2 ${isScrolled ? "text-[#234D89]" : "text-white"}`}
          >
            {isMobileMenuOpen ? <X size={28} /> : <List size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`xl:hidden fixed inset-0 top-20 bg-white z-40 transition-transform duration-300 ${
          isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <nav className="flex flex-col p-6 space-y-4">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              onClick={() => setIsMobileMenuOpen(false)}
              className={({ isActive }) =>
                `text-lg font-medium py-2 border-b border-gray-100 transition-colors ${
                  isActive ? "text-[#E73336]" : "text-[#2B2B2B] hover:text-[#E73336]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <a
            href={WHATSAPP_QUOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full mt-4"
          >
            <WhatsappLogo weight="fill" size={20} />
            Solicitar Orçamento
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
